import * as angular from 'angular';
import * as _ from 'lodash';

import { IApplicationService } from '../../services';
import { ApplicationWithStatus, ComponentDefinition } from '../../models';

class ApplicationsDatabaseTableController implements angular.IComponentController {
    isLoading: boolean;
    message: string;
    applications: ApplicationWithStatus[];
    outOfDate: ApplicationWithStatus[];
    exposedScope: {
        updateAll: () => void;
        checkAll: (force?: boolean) => void;
    };
    static $inject = ['applicationService'];

    constructor(private _applicationService: IApplicationService) {
    }

    $onInit() {
        this.refresh();
        this.exposedScope = {
            updateAll: this.updateAll.bind(this),
            checkAll: this.refresh.bind(this)
        };
    }

    refresh(force: boolean = false) {
        this.message = 'Checking databases statuses. This operation can take several minutes.';
        this.isLoading = true;
        this._applicationService.getAllWithStatus(force)
            .then(data => {
                this.setArrays(data);
            })
            .finally(() => this.isLoading = false);
    }

    updateAll() {
        this.message = 'Updating databases...';
        const applicationGuids = this.outOfDate.map(d => d.guid);
        this.updateList(applicationGuids);
    }

    update(application: ApplicationWithStatus) {
        this.message = `Updating database...`;
        this.updateList([application.guid]);
    }

    private updateList(applicationGuids: string[]) {
        this.isLoading = true;
        return this._applicationService.updateAll(applicationGuids)
            .then((data) => {
                const applications = _.chain(this.applications)
                    .filter(a => applicationGuids.indexOf(a.guid) < 0)
                    .concat(data)
                    .sortBy(d => d.name)
                    .value();
                this.setArrays(applications);
            })
            .finally(() => this.isLoading = false);
    }

    private setArrays(data: ApplicationWithStatus[]) {
        this.applications = this.map(data);
        this.outOfDate = this.applications.filter(d => !d.status);
    }


    private map(data: ApplicationWithStatus[]) {
        const r = data.map(d => {
            const result = angular.copy(d);
            result.message = d.status
                ? (d.isConfigured ? 'Your database is up to date' : 'Your database needs configuration')
                : 'Your database needs to be updated.';
            return result;
        });
        return r;
    }
}

export const wtApplicationsDatabaseTable: ComponentDefinition = {
    componentId: 'wtApplicationsDatabaseTable',
    controller: ApplicationsDatabaseTableController,
    template: require('./applicationsDatabaseTable.component.html'),
    controllerAs: 'vm',
    bindings: {
        exposedScope: '=?',
        outOfDate: '=?'
    }
};